import { useState, useEffect } from 'react';
import { ComboBox } from '@teo/components';
import { parseFilter } from '@/util';

const PaginationSingleSelect = ({
  fetch,
  defaultSort,
  render,
  supplementalOptions = [],
  filterOption = () => true,
  keyFn = (option: any) => option.id,
  renderString,
  onChange,
  value,
  setFilter,
  filter,
  displayValue,
  ...other
}: any) => {
  const [localFilter, setLocalFilter] = useState('');
  const myFilter = filter || localFilter;
  const setMyFilter = setFilter || setLocalFilter;

  const [debouncedFilter, setDebouncedFilter] = useState(myFilter);
  useEffect(() => {
    const t = setTimeout(() => setDebouncedFilter(myFilter), 250);
    return () => clearTimeout(t);
  }, [myFilter]);

  const [data, setData] = useState<any[]>([]);

  const result: any = fetch({
    offset: 0,
    count: 10,
    sort: defaultSort
      .map((sort: any) => (sort.desc ? '-' : '') + sort.id)
      .join(','),
    q: parseFilter(debouncedFilter),
  });

  useEffect(() => {
    if (result?.data) {
      const newData = (result?.data?.data as any[]).map((x) => {
        Object.assign(x, { label: render(x) });
        return x;
      });
      setData(newData);
    }
  }, [result?.data]);

  const options = [...supplementalOptions, ...data]
    .filter(filterOption)
    .filter(
      (option, index, allOptions) =>
        allOptions.findIndex(
          (otherOption) => keyFn(otherOption) === keyFn(option)
        ) === index
    )
    .map((option) =>
      option.label ? option : { ...option, label: render(option) }
    );

  return (
    <ComboBox
      onChange={(param) => {
        setMyFilter('');
        onChange(param);
      }}
      onCommitQuery={(email) => {
        setMyFilter('');
      }}
      options={options}
      query={myFilter}
      setQuery={(query) => setMyFilter(query)}
      value={value || []}
      displayValue={displayValue}
      {...other}
    />
  );
};

export { PaginationSingleSelect };
